import styled from "styled-components";

export const Page = styled.div`
  display: grid;
  margin: auto;
`;

export const Main = styled.main`
  background: white;
  max-width: 45rem;
  border-radius: 0.8rem;
  margin: auto;
  padding: 2rem;
  justify-self: center;
  margin: 3rem 1rem 0 1rem;
  align-items: center;
  justify-content: center;
`;
